var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-pager',{staticClass:"cml-pagination",attrs:{"background":"","size":"small","current-page":_vm.pageNo,"page-size":_vm.pageSize,"total":_vm.total,"page-sizes":_vm.pageSizes,"layouts":_vm.layouts},on:{"page-change":_vm.handlePageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }